// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".header-wrap[data-v-62e808a4]{width:100%;position:fixed;background:#fff;z-index:1}.header-wrap .top-header[data-v-62e808a4]{width:90%;margin:0 auto}", ""]);
// Exports
module.exports = exports;
